import __var_0__ from './dnansumpw.js';
/**

*
* Copyright (c) 2020 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var dnansumpw = __var_0__;


// VARIABLES //

var WORKSPACE = [ 0.0, 0 ];


// MAIN //

/**
* Computes the arithmetic mean of a double-precision floating-point strided array, ignoring `NaN` values and using pairwise summation.
*
* @param {PositiveInteger} N - number of indexed elements
* @param {Float64Array} x - input array
* @param {integer} stride - stride length
* @param {NonNegativeInteger} offset - starting index
* @returns {number} arithmetic mean
*
* @example
* var Float64Array = require( '@stdlib/array/float64' );
* var floor = require( '@stdlib/math/base/special/floor' );
*
* var x = new Float64Array( [ 2.0, 1.0, 2.0, -2.0, -2.0, 2.0, 3.0, 4.0, NaN ] );
* var N = floor( x.length / 2 );
*
* var v = dnanmeanpw( N, x, 2, 1 );
* // returns 1.25
*/
function dnanmeanpw( N, x, stride, offset ) {
	WORKSPACE[ 0 ] = 0.0;
	WORKSPACE[ 1 ] = 0;
	dnansumpw( N, WORKSPACE, x, stride, offset );
	return WORKSPACE[ 0 ] / WORKSPACE[ 1 ];
}


// EXPORTS //
export default dnanmeanpw;
